module.exports = __webpack_public_path__ + "static/ostendi-logo-545e1227090190ec8e338f3a096b1550.png";